import * as Sentry from '@sentry/react';

const isProduction = import.meta.env.MODE === 'production';
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (isProduction) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0.1,
    tracePropagationTargets: [/^https:\/\/playwall\.co(\/|$)/],
    tracesSampleRate: 1.0,
  });
}
